































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import {Getter, Action, Mutation} from "vuex-class";
import GenericTemplate from '@/pages/Pages/Templates/GenericTemplate.vue';
import {FormRowWings, SelectWings, TextareaWings} from 'wings-ui-components';
import { MsgTransports } from '@/store/types';
import { MailNotifyTemplateItemImpl } from '@/store/templates/types';
import {cloneDeep} from "lodash";
import CascadingOptions from "@/components/Others/CascadingOptions.vue";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {CascadingOptions, GenericTemplate, FormRowWings, SelectWings, TextareaWings}})
export default class MailNotifyTemplate extends Vue {
  @Ref('genericTemplate') genericTemplate: any;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Getter("mnServices") mnServices: any;
  @Getter("mnRoutesList") mnRoutesList: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  @Action("getMailNotifyServices") actionGetMailNotifyServices: any;

  private transport: MsgTransports = MsgTransports.MAILNOTIFY;
  private templateObject: MailNotifyTemplateItemImpl = new MailNotifyTemplateItemImpl();

  created() {
    this.setTemplate()
    this.actionGetMailNotifyServices()
  }

  get mnServicesList() {
    return this.mnServices.filter((item:any) => item.status)
  }

  get mnTemplatesList() {
    const service:any = this.mnServicesList.find((item:any) => item.id == this.template.mnServiceId);
    return service ? service?.mnTemplates : [];
  }

  @Watch('template.routes', {immediate: true})
  onRoutesChange(val: string, oldVal?: string) {
    if (!val) return
    if (!val.includes('vk')) {
      this.template.vkMessage = ''
    }
    if (!val.includes('ok')) {
      this.template.okMessage = ''
    }
  }

  @Watch('template.mnServiceId')
  onMnServiceIdChange(val: string, oldVal: string) {
    if ((val && oldVal && val != oldVal) || (!val && oldVal)) {
      this.template.mnTemplateId = null;
    }
  }

  @Watch('template.mnTemplateId', {immediate: true})
  onMnTemplateIdChange(val: string, oldVal?: string) {
    if (val)  {
      this.template.routes = 'vk,ok'
      this.template.vkMessage = ''
      this.template.okMessage = ''
    }
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  onLoadTemplate(template: any) {
    this.$emit('onLoadTemplate', template)
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    this.genericTemplate.beforeLeave(to,from,next)
  }
}
